module.exports = __webpack_public_path__ + "img/luna child_sc2.f8d9947e.png";